import React from 'react';
import './../../pg/Global.css';
import './../Palette.css';
import './GridText.css';

type GridTextProps = {
    TextList: string[],
    Flag: string
};

const GridText: React.FC<GridTextProps> = ({ TextList, Flag }) => {

    if (Flag === 'bg-alt') {
        return (
            <div className='GridTextWrapper GridTextWrapperAlt'>
                <ul className='GridTextUl' >
                    {
                        TextList.map((text) => {
                            return <li className='GridTextLi' key={text}>{text}</li>
                        })
                    }
                </ul>
            </div>
        );
    } else {
        return (
            <div className='GridTextWrapper'>
                <ul className='GridTextUl' >
                    {
                        TextList.map((text) => {
                            return <li className='GridTextLi' key={text}>{text}</li>
                        })
                    }
                </ul>
            </div>
        );
    }
};

export default GridText;

